// 翻译资源文件
const translations = {
  ja: {
    // 导航
    nav: {
      home: "トップ",
      about: "会社情報",
      guide: "ご利用ガイド",
      shop: "店舗"
    },
    
    // Header
    header: {
      language: "言語",
      japanese: "日本語",
      english: "English",
      traditionalChinese: "繁體中文"
    },
    
    // Home页面
    home: {
      promotion: {
        support24h: "24時間サポート",
        support24hDesc: "いつでもお問い合わせ可能な\n24時間カスタマーサポート",
        insurance: "安心の保険",
        insuranceDesc: "全車両に包括保険付き、\n安心してご利用いただけます",
        easyBooking: "簡単予約",
        easyBookingDesc: "オンラインで簡単3ステップ、\n最短5分で予約完了"
      }
    },
    
    // About页面
    about: {
      position: "現在位置：",
      companyInfo: "会社情報",
      slogan1: "お客様の「快適な移動」に、こだわりのサービスをお届けします。",
      slogan2: "daydaygoで楽しい旅を始めましょう",
      companyOverview: "会社概要",
      companyName: "会　社　名",
      companyNameValue: "日日高ｄａｙｄａｙｇｏ株式会社",
      establishment: "設　　　立",
      establishmentValue: "令和6年12月6日",
      capital: "資　　本　　金",
      capitalValue: "1,400万円",
      telFax: "T E L/F A X",
      telFaxValue: "080-3294-1093",
      office: "営　業　所",
      officeValue: "札幌市白石区南郷通十五丁目北8番11号",
      businessHours: "營 業 時 間",
      businessHoursValue: "9：00-21：00"
    },
    
    // Shop页面
    shop: {
      position: "現在位置：",
      shopTitle: "店舗",
      shops: {
        airport: "新千岁空港店",
        sapporo: "札幌站店"
      },
      address: "住所：",
      tel: "Tel/Fax：",
      serviceDesc1: "乗り捨てOK！出張レンタルで、旅の自由を最大化。",
      serviceDesc2: "レンタカーご利用のお客様は無料送迎をご利用いただけます。",
      serviceDesc3: "詳しくはこちら",
      toAirport: "【出発】空港または店舗から",
      toAirportDesc1: "専任スタッフが空港でお待ちし、確かにお届けします。",
      toAirportDesc2: "空港または店舗に到着されましたら、担当スタッフへ連絡し、指定のピックアップポイントまでお越しください。",
      fromShop: "【返却】空港または店舗まで",
      fromShopDesc1: "2km圏内のガソリンスタンドでガソリンを満タンしてから店舗または空港までお戻りください。",
      fromShopDesc2: "空港返却の場合は、フライト時間の約3時間前を目処に余裕を持ってお戻りください。"
    },
    
    // Guide页面
    guide: {
      position: "現在位置：",
      guideTitle: "ご利用ガイド",
      otherGuides: "その他ガイド",
      license: "国際運転免許証",
      usage: "ご利用方法",
      safety: "保険・補償"
    },
    
    // Footer
    footer: {
      title: "DayDayGo",
      slogan: "daydaygoで楽しい旅を始めましょう ",
      tel: "Tel: 080-3294-1093",
      email: "Email: daydaygosapporo@gmail.com",
      address: "本店: 札幌市白石区南郷通十五丁目北8番11号",
      copyright: "© 2025 DayDayGo. All rights reserved."
    },
    
    // 通用
    common: {
      daydaygo: "DayDayGo",
      greaterThan: " > "
    }
  },
  
  en: {
    // 导航
    nav: {
      home: "Home",
      about: "About Us",
      guide: "How to Use",
      shop: "Locations"
    },
    
    // Header
    header: {
      language: "Language",
      japanese: "Japanese",
      english: "English",
      traditionalChinese: "Traditional Chinese"
    },
    
    // Home页面
    home: {
      promotion: {
        support24h: "24-Hour Support",
        support24hDesc: "24/7 customer support\navailable 24/7 to assist you.",
        insurance: "Full Coverage Insurance",
        insuranceDesc: "All vehicles include comprehensive insurance for a worry-free driving experience.",
        easyBooking: "Easy Booking",
        easyBookingDesc: "Complete your booking online in just 3 simple steps.  "
      }
    },
    
    // About页面
    about: {
      position: "Current Location: ",
      companyInfo: "Company Information",
      slogan1: "We deliver meticulous services for your 'comfortable mobility'.",
      slogan2: "Start your enjoyable journey with daydaygo",
      companyOverview: "Company Overview",
      companyName: "Company Name",
      companyNameValue: "DayDayGo Corporation",
      establishment: "Established",
      establishmentValue: "December 6, 2024 (Reiwa 6)",
      capital: "Capital",
      capitalValue: "14 million yen",
      telFax: "TEL/FAX",
      telFaxValue: "080-3294-1093",
      office: "Office",
      officeValue: "8-11 Kita, 15-chome, Minami-go-dori, Shiroishi-ku, Sapporo",
      businessHours: "Business Hours",
      businessHoursValue: "9:00-21:00"
    },
    
    // Shop页面
    shop: {
      position: "Current Location: ",
      shopTitle: "Shops",
      shops: {
        airport: "New Chitose Airport Store",
        sapporo: "Sapporo Station Store"
      },
      address: "Address: ",
      tel: "Tel/Fax: ",
      serviceDesc1: "One-way drop-off available! Maximize travel freedom with our dispatch rental service.",
      serviceDesc2: "Free shuttle service is provided for customers using rental cars.",
      serviceDesc3: "Learn more",
      toAirport: "Departure from Airport",
      toAirportDesc1: "Dedicated staff will wait at the airport and deliver your vehicle securely.",
      toAirportDesc2: "Upon airport arrival, collect your luggage and enjoy free shuttle and vehicle delivery service.",
      fromShop: "Return to Shop",
      fromShopDesc1: "Please first refuel at a petrol station within 2 kilometres before returning to the store.",
      fromShopDesc2: "Please return approximately 3 hours before your flight time to allow ample time.",
      fromShopDesc3: "Airport return is smooth! Save time and have plenty of time for boarding."
    },
    
    // Guide页面
    guide: {
      position: "Current Location: ",
      guideTitle: "Usage Guide",
      otherGuides: "Other Guides",
      license: "International Driver's License",
      usage: "How to Use",
      safety: "Insurance & Coverage"
    },
    
    // Footer
    footer: {
      title: "DayDayGo",
      slogan: "Every journey filled with smiles begins with DayDayGo.",
      tel: "Tel: 080-3294-1093",
      email: "Email: daydaygosapporo@gmail.com",
      address: "Head Office: B-5-15 Kita-Shiroishi, Minami-go-dori, Shiroishi-ku, Sapporo, Japan",
      copyright: "© 2025 DayDayGo. All rights reserved."
    },
    
    // 通用
    common: {
      daydaygo: "DayDayGo",
      greaterThan: " > "
    }
  },
  
  zh_tw: {
    // 导航
    nav: {
      home: "首頁",
      about: "公司簡介",
      guide: "使用指南",
      shop: "店舖"
    },
    
    // Header
    header: {
      language: "語言",
      japanese: "日語",
      english: "英語",
      traditionalChinese: "繁體中文"
    },
    
    // Home页面
    home: {
      promotion: {
        support24h: "24小時支援",
        support24hDesc: "隨時可聯繫的\n24小時客戶支援服務",
        insurance: "安心保險",
        insuranceDesc: "所有車輛均附帶綜合保險，\n讓您安心使用",
        easyBooking: "輕鬆預訂",
        easyBookingDesc: "簡單3步驟線上預訂，\n最快5分鐘完成"
      }
    },
    
    // About页面
    about: {
      position: "目前位置：",
      companyInfo: "公司簡介",
      slogan1: "我們為您提供「舒適便捷」安心駕駛服務. ",
      slogan2: "愉快的旅程由daydaygo開始",
      companyOverview: "公司概覽",
      companyName: "公　司　名　稱",
      companyNameValue: "日日高ｄａｙｄａｙｇｏ股份有限公司",
      establishment: "成　　立",
      establishmentValue: "令和6年12月6日",
      capital: "資　　本　　額",
      capitalValue: "1,400萬日圓",
      telFax: "電　話／傳　真",
      telFaxValue: "080-3294-1093",
      office: "營　業　所",
      officeValue: "札幌市白石區南鄉通十五丁目北8番11號",
      businessHours: "營　業　時　間",
      businessHoursValue: "9：00-21：00"
    },
    
    // Shop页面
    shop: {
      position: "目前位置：",
      shopTitle: "店舖",
      shops: {
        airport: "新千歲機場店",
        sapporo: "札幌站店"
      },
      address: "地址：",
      tel: "電話／傳真：",
      serviceDesc1: "daydaygo有便捷異地還取車服務！",
      serviceDesc2: "客戶可享受免費接送服務！",
      toAirport: "出發 從機場/門店出發",
      toAirportDesc1: "工作人員會在機場等候，確保順利交付車輛。",
      toAirportDesc2: "抵達機場/門店後，聯繫客服，並到達指定取車位置！",
      fromShop: "返回 歸還至門店/機場",
      fromShopDesc1: "請先到還取2km內的加油站加滿油後再返回門店。",
      fromShopDesc2: "機場還車建議在航班時間約三小時前歸還車輛，以確保有充裕的時間。"
    },
    
    // Guide页面
    guide: {
      position: "目前位置：",
      guideTitle: "使用指南",
      otherGuides: "其他指南",
      license: "國際駕駛執照",
      usage: "使用方法",
      safety: "保險與保障"
    },
    
    // Footer
    footer: {
      slogan: "承載著家人歡笑的旅途，從daydaygo開始 ",
      tel: "電話：080-3294-1093",
      email: "電子郵件：daydaygosapporo@gmail.com",
      address: "總公司：札幌市白石區南鄉通十五丁目北8番11號",
      copyright: "© 2025 DayDayGo. 版權所有。"
    },
    
    // 通用
    common: {
      daydaygo: "DayDayGo",
      greaterThan: " > "
    }
  }
};

export default translations;
